import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IBetPosition } from '../types/betPosition';

interface ILoadBetPositionSuccessPayload extends IBetPosition {
  serviceId: string;
}

export const LOAD_BET_POSITION_SUCCESS = 'BET_POSITION :: LOAD_BET_POSITION_SUCCESS';

export type TLoadBetPositionSuccessAction = IReduxAction<
  typeof LOAD_BET_POSITION_SUCCESS,
  ILoadBetPositionSuccessPayload
>;

export const loadBetPositionSuccess = actionGenerator<typeof LOAD_BET_POSITION_SUCCESS, ILoadBetPositionSuccessPayload>(
  LOAD_BET_POSITION_SUCCESS,
);
